export const URLS = {
    REDIRECT_IFRAME: `${process.env.REACT_APP_BASE_URL}/pages/calculadora`,
    API_UPDATE_SHIPPING_RATES: `${process.env.REACT_APP_BACKEND_URL}/api/v1/calculator/shipping-rates/`,
    INSURANCE_INFO: `${process.env.REACT_APP_BASE_URL}/pages/que-cubre-tu-seguro-de-envio`,
    CONTACT_US: process.env.REACT_APP_CONTACT_US,
    API_REGISTER_USER: `${process.env.REACT_APP_BACKEND_URL}/api/v1/clients/`,
    TERMS_AND_CONDITIONS: `${process.env.REACT_APP_BASE_URL}/pages/terminos-y-condiciones-del-servicio-wuuju`,
    PRIVACY_POLICY: `${process.env.REACT_APP_BASE_URL}/pages/politica-de-privacidad`,
    API_REGISTER_USER_SECONDARY: `${process.env.REACT_APP_BACKEND_URL}/api/v1/clients/profile/`,
    API_LOGIN: `${process.env.REACT_APP_BACKEND_URL}/api/v1/auth/login/`,
    API_PASSWORD_RESET: `${process.env.REACT_APP_BACKEND_URL}/api/v1/email/auth/password-reset/`,
    API_CHANGE_PASSWORD: `${process.env.REACT_APP_BACKEND_URL}/api/v1/auth/password-reset/confirm/`,
    VIRTUAL_LOCKER_INSTRUCTIONS: `${process.env.REACT_APP_BASE_URL}/pages/casillero-virtual-instructivo`,
    API_PREALERT_PACKAGE: `${process.env.REACT_APP_BACKEND_URL}/api/v1/packages/`,
    RECAPTCHA_SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
    API_AUTH_USER: `${process.env.REACT_APP_BACKEND_URL}/api/v1/clients/me/`,
    API_ADDRESS_CHANGE: `${process.env.REACT_APP_BACKEND_URL}/api/v1/shipping-addresses/`,
};